export enum SvgStaticNames {
  POLYGON = 'POLYGON',
  LINE = 'LINE',
}
